import EnterpriseIcon, { ArrowLeftIcon, ArrowRightIcon } from '@enterprise-ui/icons';
import React__default, { Fragment } from 'react';
import Button from '../../../Button.js';
import ButtonGroup from '../../../ButtonGroup.js';

var ResizeButton = function ResizeButton(_ref) {
  var columnTextId = _ref.columnTextId,
    headerWidth = _ref.headerWidth,
    setHeaderWidth = _ref.setHeaderWidth;
  //track mouse position
  var x;
  var resizingInProgress = function resizingInProgress(e) {
    var deltaWidth = e.clientX - x;
    setHeaderWidth(headerWidth + deltaWidth);
  };
  var _resizingEnd = function resizingEnd() {
    window.removeEventListener('mousemove', resizingInProgress);
    window.removeEventListener('mouseup', _resizingEnd);
  };
  var resizingStart = function resizingStart(e) {
    x = e.clientX;
    window.addEventListener('mousemove', resizingInProgress);
    window.addEventListener('mouseup', _resizingEnd);
  };
  var handleResizeClick = function handleResizeClick(e) {
    resizingStart(e);
  };
  var handleA11yResizeClick = function handleA11yResizeClick(direction) {
    if (direction === 'expand') {
      setHeaderWidth(headerWidth + 20);
    } else if (direction === 'shrink') {
      if (headerWidth > 0) {
        setHeaderWidth(headerWidth - 20);
      }
    }
  };
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("button", {
    onMouseDown: handleResizeClick,
    className: "C-TableResizeButton",
    tabIndex: -1 //no focus move right to A11y button
  }), /*#__PURE__*/React__default.createElement(ButtonGroup, {
    className: "C-TableResizeButton__A11y"
  }, /*#__PURE__*/React__default.createElement(Button, {
    iconOnly: true,
    "aria-describedby": columnTextId,
    "aria-label": "shrink column",
    onClick: function onClick() {
      return handleA11yResizeClick('shrink');
    }
  }, /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
    icon: ArrowLeftIcon
  })), /*#__PURE__*/React__default.createElement(Button, {
    iconOnly: true,
    "aria-describedby": columnTextId,
    "aria-label": "expand column",
    onClick: function onClick() {
      return handleA11yResizeClick('expand');
    }
  }, /*#__PURE__*/React__default.createElement(EnterpriseIcon, {
    icon: ArrowRightIcon
  }))));
};

export { ResizeButton as default };
